var map = {
	"./arrow.svg": "./assets/icon/arrow.svg",
	"./icon-arrow-button.svg": "./assets/icon/icon-arrow-button.svg",
	"./icon-arrow-link.svg": "./assets/icon/icon-arrow-link.svg",
	"./icon-arrow.svg": "./assets/icon/icon-arrow.svg",
	"./icon-calendar.svg": "./assets/icon/icon-calendar.svg",
	"./icon-chevron-down.svg": "./assets/icon/icon-chevron-down.svg",
	"./icon-chevron.svg": "./assets/icon/icon-chevron.svg",
	"./icon-download.svg": "./assets/icon/icon-download.svg",
	"./icon-email.svg": "./assets/icon/icon-email.svg",
	"./icon-event.svg": "./assets/icon/icon-event.svg",
	"./icon-facebook.svg": "./assets/icon/icon-facebook.svg",
	"./icon-footer-pro.svg": "./assets/icon/icon-footer-pro.svg",
	"./icon-has-mega-menu.svg": "./assets/icon/icon-has-mega-menu.svg",
	"./icon-instagram.svg": "./assets/icon/icon-instagram.svg",
	"./icon-linkedin.svg": "./assets/icon/icon-linkedin.svg",
	"./icon-map.svg": "./assets/icon/icon-map.svg",
	"./icon-mobile-menu-contact.svg": "./assets/icon/icon-mobile-menu-contact.svg",
	"./icon-mobile-menu-phone.svg": "./assets/icon/icon-mobile-menu-phone.svg",
	"./icon-mobile-menu-pro.svg": "./assets/icon/icon-mobile-menu-pro.svg",
	"./icon-news.svg": "./assets/icon/icon-news.svg",
	"./icon-particulier.svg": "./assets/icon/icon-particulier.svg",
	"./icon-phone-2.svg": "./assets/icon/icon-phone-2.svg",
	"./icon-phone.svg": "./assets/icon/icon-phone.svg",
	"./icon-pin.svg": "./assets/icon/icon-pin.svg",
	"./icon-pro.svg": "./assets/icon/icon-pro.svg",
	"./icon-time.svg": "./assets/icon/icon-time.svg",
	"./icon-title-h1.svg": "./assets/icon/icon-title-h1.svg",
	"./icon-title.svg": "./assets/icon/icon-title.svg",
	"./icon-twitter.svg": "./assets/icon/icon-twitter.svg",
	"./icon-user.svg": "./assets/icon/icon-user.svg",
	"./icon-way.svg": "./assets/icon/icon-way.svg",
	"./icon-youtube.svg": "./assets/icon/icon-youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/icon sync recursive \\.svg$";